<script>
export default {
  props: {
    form: Object,
    additions: {
      type: Array,
      default() {
        return [];
      },
    },
    value: Boolean,
  },
  data() {
    return {
      show: false,
      dialog: false,
    };
  },
  computed: {
    isLongDescription() {
      return this.additions
        ? !!this.additions.find(i => i.Title && i.Title.length > 24)
        : false;
    },
  },
  methods: {
    dialogSubmit() {
      this.$emit('input', false);
      this.$emit('submit');
    },
    keyMonitor(ev, itemProp) {
      let event = this.form[itemProp];
      const j = this.form[itemProp].split('.');
      let e;
      if (j != null) {
        for (let k = 0; k < j.length; k += 1) {
          if (Number.isNaN(j[k])) {
            break;
          }
        }
      }
      if (event != null && event.length === 2) {
        if (Number.isNaN(event)) {
          this.form[itemProp] = '';
        } else {
          if (event > 31) {
            event = 31;
          } else if (event === '00') {
            event = '01';
          }
          event += '.';
          this.form[itemProp] = event;
        }
      } else if (event != null && event.length === 5) {
        if (Number.isNaN(event)) {
          this.form[itemProp] = '';
        } else {
          event += '.';
          this.form[itemProp] = event;
        }
      } else if (event != null && event.length === 10) {
        e = event.split('.');
        let t;
        if (e != null) {
          for (t = 0; t < e.length; t += 1) {
            if (Number.isNaN(e[t])) {
              this.form[itemProp] = '';
              break;
            }
            if (t === 0) {
              e[t] = e[t] > 31 ? 31 : '01';
            } else {
              e[t] = e[t] > 12 ? 12 : '01';
            }

            if (e.length > 2) {
              this.form[itemProp] = `${e[0]}.${e[1]}.${e[2]}`;
            }
          }
        }
      }
      e = event.split('.');
      if (e != null) {
        for (let t = 0; t < e.length; t += 1) {
          if (Number.isNaN(e[t])) {
            this.form[itemProp] = '';
            break;
          }
        }
      }
    },
  },
  mounted() {
  },
};
</script>
<template>
  <el-dialog
    title="Дополнительные фильтры"
    :visible="value"
    @update:visible="$emit('input', $event)"
    size="tiny"
    modal-append-to-body
  >
    <el-form
      label-position="top"
    >
      <el-form-item
        v-for="(item, key) in additions"
        :key="key"
        :class="item.Title.length > 24 ? 'longItem' : ''"
        :label="item.Title"
        class="order-form-filter-item"
      >
        <el-select
          v-if="item.Type === 'Флажок' || item.Type ==='Справочник' || item.Type ==='Справочник с множественным выбором'"
          v-model="form[item.FilterName]"
          multiple
          style="width: 100%;"
          size="small"
        >
          <el-option
            v-for="(op, index) in item.Options"
            :key="index + '' + op.value"
            :value="op.value"
            :label="op.label"
          ></el-option>
        </el-select>
        <el-input
          v-else-if="item.Type === 'Дата'"
          v-model="form[item.FilterName]"
          @keyup.native="keyMonitor($event, item.FilterName)"
          size="small"
          :maxlength="10"
        />
        <el-input
          v-else
          v-model="form[item.FilterName]"
          size="small"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('input', false)">Закрыть</el-button>
      <el-button type="primary" @click="dialogSubmit">Найти</el-button>
    </div>
  </el-dialog>
</template>
<style lang="scss">
  .order-form-filter-item {
    margin-bottom: 8px;
    .el-input__inner {
      width: 100%;
      height: 30px;
    }
    .el-select {
      width: 100%;
      height: 30px;
    }
    .el-form-item__label {
      padding: 0 0 0 0;
    }
  }
</style>
